/**
 * AdminLayout — Layout principal avec sidebar + header + SimulationBanner.
 * S5.4-11 : la SimulationBanner est le composant critique (bannière orange si simulated).
 */
import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar.tsx';
import SimulationBanner from './SimulationBanner.tsx';
import { useSDK } from '../../context/SDKContext.tsx';

export default function AdminLayout(): React.ReactElement {
  const { isSimulated, reconnect } = useSDK();

  return (
    <div className="flex h-screen bg-background">
      <Sidebar />
      <div className="flex flex-col flex-1 overflow-hidden">
        {isSimulated && <SimulationBanner onReconnect={reconnect} />}
        <main className="flex-1 overflow-auto p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
